/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import domUtil from 'scripts/utils/dom';

export const QualifyingSectionalEventHeader = BaseControl.extend({
    _tabsContentRendered: false,

    init: function() {
        this._super();
        this.initLoad = true;
        this.contentTabs = null;
        this.tabs = null;
        this.awaitRenderTabsContent().then(() => {
            this.findContentTabs();
        });
    },

    findContentTabs: function() {
        let searchInterval;
        let searchContent = () => {
            this.contentTabs = this.$element
                .closest('.l-qualifying-sectional-event')
                .find('.s-tabs-content__item');
            this.tabs = this.$element
                .closest('.l-qualifying-sectional-event')
                .find('.s-tabs__item');

            if (
                this.tabs &&
                this.tabs.length &&
                this.contentTabs &&
                this.contentTabs.length
            ) {
                clearInterval(searchInterval);
                this._tabsContentRendered = true;
                this.defaultIndex = this.contentTabs.first().data('index');
                this.activeRoute();
            }
        };
        searchInterval = setInterval(() => {
            if (!this.contentTabs || !this.contentTabs.length) {
                searchContent();
            } else {
                clearInterval(searchInterval);
            }
        }, 300);
        searchContent();
    },

    awaitRenderTabsContent: function() {
        const awaiter = this.can.Deferred();

        if (window.CQ) {
            window.CQ.WCM.addListener('editablesready', () => {
                awaiter.resolve();
            });
        } else {
            awaiter.resolve();
        }

        return awaiter;
    },

    onTabChange: function(el) {
        if (window.CQ) {
            var tabIndex = el.getAttribute('data-index');
            var selected = el.classList.contains('is-selected');
            window.CQ.WCM.USOPEN.onTabChange(tabIndex, selected);
        }
    },

    activeRoute: function() {
        can.route.bind('change', (ev, attr, how, newVal, oldVal) => {
            if (attr === 'tab') {
                this.selectTab(newVal);
            }
        });

        can.route.ready();

        var tab = can.route.attr('tab');

        if (!tab) {
            can.route.attr({ tab: this.defaultIndex });
        } else {
            this.selectTab(tab);
        }
    },

    scrollToTabs: function() {
        domUtil.scrollTop(this.element.offset().top);
    },

    setActiveTabElement(el, tab) {
        const $el = $(el);

        if ($el.data('index') === tab) {
            $el.addClass('is-selected');
        } else {
            $el.removeClass('is-selected');
        }
    },

    selectTab: function(tab) {
        if (this.initLoad) {
            this.scrollToTabs();
            this.initLoad = false;
        }

        this.tabs.each((i, el) => {
            this.setActiveTabElement(el, tab);
        });

        this.contentTabs.each((i, el) => {
            this.setActiveTabElement(el, tab);
            this.onTabChange(el);
        });
    },

    '.s-tabs__item click': function($element) {
        if (this._tabsContentRendered && !$element.hasClass('is-selected')) {
            can.route.attr('tab', $element.attr('data-index'));
        }
    },

    '.s-tabs__select change': function($element) {
        if (this._tabsContentRendered) {
            can.route.attr('tab', $element.val());
        }
    },
});
